module.exports = __webpack_public_path__ + "static/Frogsong2-d75b03f530370826bb3677083b44d711.png";